import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { MEXICO_PROVINCES } from "_common/regions/regions";

export const oaxacaAttraction: TAttraction[] = [
    {
        name: "Bahías de Huatulco International Airport (HUX)",
        type: ATTRACTION_TYPE.AIRPORT,
        coordinates: { lat: 15.7720758, lng: -96.2588536 },
        region: MEXICO_PROVINCES.OAXACA,
    },
    {
        name: "Xoxocotlán International Airport (OAX)",
        type: ATTRACTION_TYPE.AIRPORT,
        coordinates: { lat: 17.0007518, lng: -96.7220523 },
        region: MEXICO_PROVINCES.OAXACA,
    },
    {
        name: "ADO Oaxaca",
        type: ATTRACTION_TYPE.BUS_STATION,
        coordinates: { lat: 17.0707702, lng: -96.7169667 },
        region: MEXICO_PROVINCES.OAXACA,
    },
];
